// extracted by mini-css-extract-plugin
module.exports = {"modal":"PaymentLinkDialog_modal__3nhj5","content":"PaymentLinkDialog_content__2CBW6"};